// extracted by mini-css-extract-plugin
export var standaloneTable = "_e7-0";
export var standaloneTableWithBodyFill = "_e7-1";
export var withExtraHeader = "_e7-2";